import { Modal, Button } from '@/components/ui';

export interface Step0PromptProps {
  open: boolean;
  onShowMeHow: () => void;
  onNotNow: () => void;
}

/**
 * YAR-238 Step 0 — initial prompt asking the user whether they want to
 * see the walkthrough. Renders ONLY when `aha_walkthrough_state ===
 * 'pending'` AND Gmail is connected. Both CTAs are terminal for Step 0
 * itself: tapping either prevents Step 0 from ever reappearing (AC 3).
 */
export function Step0Prompt({ open, onShowMeHow, onNotNow }: Step0PromptProps) {
  return (
    <Modal
      open={open}
      // Backdrop / Escape acts like "Not now" — the AC says force-quit
      // without tapping a CTA keeps state pending, but a deliberate
      // backdrop tap is still a dismissal signal we should honour.
      onClose={onNotNow}
      bare
    >
      <div className="flex flex-col gap-5 p-5">
        <div className="flex flex-col gap-1.5 text-center">
          <p className="text-xl font-semibold text-foreground">
            Have older emails you want Yaruta to review?
          </p>
          <p className="text-base text-foreground">
            Yaruta reviews emails after Gmail is connected. If an important
            email arrived before setup, you can still bring it in.
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <Button
            variant="primary"
            fullWidth
            onClick={onShowMeHow}
          >
            Show me how
          </Button>
          <button
            type="button"
            onClick={onNotNow}
            className="w-full text-foreground font-semibold text-base leading-6 py-1.5 px-2 cursor-pointer"
          >
            Not now
          </button>
        </div>
      </div>
    </Modal>
  );
}
